export interface GuardRedirectArgs {
  /** True when the !isSignedIn transition is an intentional logout, not an
   *  unauthenticated bounce. Sourced from AuthContext's loggingOutRef. */
  loggingOut: boolean;
  /** The private route the guard is redirecting away from. */
  pathname: string;
}

/**
 * Decides the history state the private-route guard attaches to its
 * `<Navigate to="/log-in">` redirect.
 *
 * TRIL-216 preserves the original URL as `from` so an unauthenticated visitor
 * who deep-linked a protected route is returned there after login. But an
 * explicit logout also flips the guard to its `!isSignedIn` branch (the
 * still-mounted private route re-renders on logout's state change), and there
 * the captured `from` is spurious — there is no destination the user was
 * trying to reach. TRIL-231: suppress `from` during logout so
 * resolvePostLoginRoute falls through to the user's landingPage preference.
 */
export function resolveGuardRedirectState({
  loggingOut,
  pathname,
}: GuardRedirectArgs): { from: string } | undefined {
  if (loggingOut) return undefined;
  return { from: pathname };
}
